import { render } from "./mobile_post_status_button.vue?vue&type=template&id=6c0a4c69"
import script from "./mobile_post_status_button.js?vue&type=script&lang=js"
export * from "./mobile_post_status_button.js?vue&type=script&lang=js"

import "./mobile_post_status_button.vue?vue&type=style&index=0&id=6c0a4c69&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__